import { CardHeader } from '@hue/design-system';
import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export function SectionCardHeader({
  title,
  icon: Icon,
  iconClassName = 'text-brand-500',
  children,
}: {
  title: string;
  icon: LucideIcon;
  iconClassName?: string;
  children?: ReactNode;
}) {
  return (
    <div className="px-4 pt-3 [&>header]:mb-0">
      <CardHeader
        title={title}
        icon={<Icon className={`size-4 ${iconClassName}`} aria-hidden="true" />}
        action={children}
      />
    </div>
  );
}
